// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./license/index.js": { enumerable: true, get() { return require("/vercel/path0/docs/license/index.js"); } },
  "./license/index.mdx": { enumerable: true, get() { return require("/vercel/path0/docs/license/index.mdx"); } },
  "./privacy/index.js": { enumerable: true, get() { return require("/vercel/path0/docs/privacy/index.js"); } },
  "./privacy/index.mdx": { enumerable: true, get() { return require("/vercel/path0/docs/privacy/index.mdx"); } },
  "./terms/index.js": { enumerable: true, get() { return require("/vercel/path0/docs/terms/index.js"); } },
  "./terms/index.mdx": { enumerable: true, get() { return require("/vercel/path0/docs/terms/index.mdx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;